import React from 'react';

import Section from 'react-scale/components/elements/section';
import SectionTitle from 'react-scale/components/elements/section-title';
import { UseCase } from 'react-scale/components/solutions/use-case';

const UseCases = ({ id, overtitle, title, subtitle, list, bg }) => (
  <Section id={id} bg={bg}>
    <SectionTitle overtitle={overtitle} title={title} subtitle={subtitle} />
    <div className="grid gap-16 sm:grid-cols-2 lg:grid-cols-3 gap-y-20 md:pb-10">
      {list.map(item => (
        <UseCase
          key={`useCase-${item.link}`}
          width="100%"
          height="100%"
          label={item.label}
          imgSrc={item.src}
          imgSrcFront={item.srcHover}
          link={item.link}
          text={item.text}
        />
      ))}
    </div>
  </Section>
);

export default UseCases;
